import React from "react";
import { EmptyHeaderComponent } from "./components/HeaderComponent/EmptyHeaderComponent";
import { HeaderSpacer } from "./layouts/_layout-helpers/spacers";
import { Spacer } from "./components/_shared-components/arrangement/Space";
import { ContentContainer } from "./components/_shared-components/arrangement/Container";
import { PageHeadline, PageHeadlineMedium } from "./components/_shared-components/ui-elements/PageHeadline";
import { SwarovskiButton } from "./components/_shared-components/ui-elements/SwarovskiButton";

export const EditorsAppLayoutShell: React.FC<React.PropsWithChildren<{ headline?: string }>> = props => {
  return (
    <>
      <EmptyHeaderComponent />

      <HeaderSpacer />

      <ContentContainer>
        <SwarovskiButton as={"a"} variant={"plain-underline"} size={"small"} link={"/"} isInternal={true}>
          {"<"} go back home
        </SwarovskiButton>
      </ContentContainer>

      {props.headline ? (
        <>
          <ContentContainer>
            <PageHeadlineMedium>{props.headline}</PageHeadlineMedium>
          </ContentContainer>

          <Spacer size={"md"} />
        </>
      ) : (
        <Spacer size={"md"} />
      )}

      <ContentContainer className={"expand u-d-flex u-fd-column"}>{props.children}</ContentContainer>
    </>
  );
};
